import React from "react";

const TeamSection = ({ staffs = [] }) => {
  // console.log({ staffs });

  return (
    <>
      <h2 className="text-3xl font-bold mb-6">Meet the Team</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {staffs.map((staff, idx) => (
          <div
            key={staff._id || idx}
            className="text-center bg-dry p-4 rounded shadow-sm hover:shadow-md transition"
          >
            <img
              src={staff.photo || `https://i.pravatar.cc/150?img=${idx + 1}`}
              alt={staff.name}
              className="w-24 h-24 mx-auto rounded-full mb-2 object-cover"
            />
            <h4 className="font-semibold">{staff.name}</h4>
            <p className="text-sm text-gray-500">
              {staff.bio?.trim() || "Team Member"}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default TeamSection;
